import _ from 'lodash';
import { connect } from 'react-redux';
import { search, add } from '../../modules/billing/quickbooksFuelItem';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state) => {
	/** @namespace state.lists.quickbooksFuelItemIds **/
	/** @namespace state.maps.quickbooksFuelItem **/
	let quickbooksFuelItems = undefined;
	if (state.lists.quickbooksFuelItemIds) {
		quickbooksFuelItems = _.map(
			state.lists.quickbooksFuelItemIds,
			id => state.maps.quickbooksFuelItem[id]
		);
	}
	return {
		quickbooksFuelItems,
		quickbooksItemMap : state.maps.quickbooksItem,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	addQuickbooksFuelItem : add,
	searchQuickbooksFuelItems : search,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
